import _constantUtil from '../utils/Constant';

const evalution = (_constantUtil.ENVIORNMENT === 'development');

const config = {
    appBaseUrl : (evalution ? process.env.REACT_APP_BASE_URL : '') + _constantUtil.API_PREFIX,
    // socketBaseUrl : (evalution ? _constantUtil.SOCKET_DEVELOPMENT_URL : _constantUtil.SOCKET_STAGING_URL)
}

export default config;